import React from 'react'
import styled from 'styled-components'

import Image from '@/components/image'
import {Text} from '@/components/text'
import type {UnifiedSignupModalSocialProofFragment} from '@/graphql-types'

import {Card} from '../components/card'

type SocialProofProps = {
    slice: UnifiedSignupModalSocialProofFragment
}

export const SocialProof = ({slice}: SocialProofProps) => {
    const content = slice.items[0]

    if (!content) {
        return null
    }

    return (
        <Container>
            <StyledCard>
                <StyledImage image={content.image} />
                <Quote $variant="paragraph-base">"{content.quote}"</Quote>
                <Author $variant="paragraph-base" $color="lightMuted">
                    {`— ${content.full_name}, ${content.person_byline}`}
                </Author>
            </StyledCard>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-inline: ${({theme}) => theme.spacings.s60};
`

const StyledCard = styled(Card)`
    padding: ${({theme}) => theme.spacings.s24};
    padding-bottom: ${({theme}) => theme.spacings.s32};
`

const StyledImage = styled(Image)`
    width: 100%;
    margin-bottom: ${({theme}) => theme.spacings.s32};
`

const Quote = styled(Text)`
    text-align: center;
    margin-bottom: ${({theme}) => theme.spacings.s24};
`

const Author = styled(Text)`
    text-align: center;
`
